import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button, useToast } from '../components/ui';
import { useResetPasswordMutation } from '../store/customersApi';

export default function RestablecerContrasena() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const toast = useToast();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.warning({ title: 'Contraseña muy corta', description: 'Debe tener al menos 8 caracteres.' });
      return;
    }
    try {
      await resetPassword({ token, password }).unwrap();
      toast.success({ title: 'Contraseña actualizada', description: 'Ya podés iniciar sesión.' });
      navigate('/login');
    } catch (e: any) {
      toast.error({ title: 'El enlace no es válido', description: e?.data?.message ?? 'Pedí un nuevo enlace.' });
    }
  };

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 text-center">
        <div>
          <p className="text-sm text-slate-600 mb-3">Este enlace no es válido.</p>
          <Link to="/olvide-mi-contrasena" className="text-indigo-600 font-semibold text-sm hover:underline">Pedir un nuevo enlace</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={handleSubmit} className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-8 space-y-4">
        <h1 className="font-heading font-extrabold text-2xl text-slate-900 text-center mb-2">Elegí tu nueva contraseña</h1>
        <div className="relative">
          <input required type="password" placeholder="Nueva contraseña (mínimo 8 caracteres)" value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-slate-50 border border-slate-200 focus:border-indigo-500/50 focus:bg-white rounded-xl pl-10 pr-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none transition-colors" />
          <Lock className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
        </div>
        <Button type="submit" variant="primary" size="lg" loading={isLoading} className="w-full">
          Guardar nueva contraseña
        </Button>
      </form>
    </div>
  );
}
